import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMotiveIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "-14 -15 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_81_2025)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M37.4778 88.5869C57.593 88.5869 73.9566 72.2578 73.9566 52.187C73.9566 32.1152 57.593 15.7861 37.4778 15.7861C17.3635 15.7861 0.999023 32.1152 0.999023 52.187C0.999023 72.2578 17.3635 88.5869 37.4778 88.5869Z",
				stroke: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.6028 73.7998C66.7171 73.7998 83.0816 57.4707 83.0816 37.4008C83.0816 17.3291 66.7171 1 46.6028 1C26.4876 1 10.124 17.3291 10.124 37.4008C10.124 57.4707 26.4876 73.7998 46.6028 73.7998Z",
				stroke: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.5209 88.5937C75.6361 88.5937 91.9997 72.2646 91.9997 52.1938C91.9997 32.1221 75.6361 15.793 55.5209 15.793C35.4066 15.793 19.043 32.1221 19.043 52.1938C19.043 72.2646 35.4066 88.5937 55.5209 88.5937Z",
				stroke: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_81_2025",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 93,
			height: 90,
			fill: "white"
		})
	}) })]
});
export default SvgMotiveIcon;
